import React from 'react';
import { Header } from '../components/Header';
import { EMICalculator } from '../components/EMICalculator';
import { Footer } from '../components/Footer';
import { WhatsAppButton } from '../components/WhatsAppButton';
import { CalcBreadcrumb, CalcRelatedLinks } from '../components/CalcBreadcrumb';

const EMICalculatorPage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <WhatsAppButton />
      
      {/* Page Header */}
      <div className="bg-white pt-24 sm:pt-28 md:pt-32 pb-10 sm:pb-12">
        <div className="container mx-auto px-4">
          <CalcBreadcrumb name="EMI Calculator" path="/calculators/emi" />
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-slate-900 mb-3 sm:mb-4 text-center leading-[1.1]">
            EMI <span className="text-emerald-600">Calculator</span>
          </h1>
          <p className="text-base sm:text-lg text-slate-600 text-center max-w-2xl mx-auto">
            Calculate your monthly EMI for home loans, personal loans, and more
          </p>
          <CalcRelatedLinks links={[['Home Loan', '/home-loan'], ['Business Loans', '/business-loans'], ['Loan Against Property', '/loan-against-property']]} />
        </div>
      </div>

      {/* Calculator Section */}
      <EMICalculator />
      
      <Footer />
    </div>
  );
};

export default EMICalculatorPage;